// The following two lines must be the first lines in src/index.js in order to get IE11 to work.
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { CookiesProvider } from 'react-cookie';

import './index.css';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <BrowserRouter>
    <CookiesProvider>
    <App />
    </CookiesProvider>
  </BrowserRouter>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx